import script from "./addressIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./addressIndex.vue?vue&type=script&setup=true&lang=js"

import "./addressIndex.vue?vue&type=style&index=0&id=583e9392&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-583e9392"]])

export default __exports__